/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OpsUserDetails = {
    id: number;
    fullName: string;
    email: string;
    role: OpsUserDetails.role;
    correctionQueueId?: number;
};

export namespace OpsUserDetails {

    export enum role {
        ADMIN = 'ADMIN',
        OPERATOR = 'OPERATOR',
    }


}

